import { render, staticRenderFns } from "./FileForm10.vue?vue&type=template&id=c6e2dffe&scoped=true&"
import script from "./FileForm10.vue?vue&type=script&lang=js&"
export * from "./FileForm10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e2dffe",
  null
  
)

export default component.exports